module.exports = __webpack_public_path__ + "img/loans.43e59c3d.svg";